import { useEffect, useState } from "react";
import Blur from "../assets/blur_on.svg";
import Gradient from "../assets/gradient.svg";
import Opacity from "../assets/opacity.svg";
import Shadow from "../assets/shadow.svg";
import { aspectRatios, cropButtons } from "../ImageEditorModal";
import { Button, Slider, Switch } from "antd";
import {
  InfoCircleOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useGlobalStore } from "../../../../../../stores/globalBackendStore";
import _ from "lodash";
import { fcbResizeTemplates } from "../../../../../backend/pages/Dashboard/TemplateEditPopup";

export const GKPresetColors = {
  pink: "#ad042b",
  red: "#363d43",
  black: "#8A2BE2",
  gray: "#008000"
}

export const PresetColors = {
  white: "#363d43",
  red: "#ad042b",
  black: "#111111"
}

export const ResultTimes = {
  halfTime: "45",
  fullTime: "90",
}

function EditTab({
  backgroundAndResize,
  updateWithUndo,
  effects,
  setEffects,
  setSelectedRatio,
  addLayer,
  addOrUpdatePreset,
  addOrUpdateGkPreset,
  isFcbTemplate,
  templateData,
  setCLStarsOnOrOff,
  setCropOption,
  cropOption,
  setSelectedJersey,
  setSelectedResultTime,
}) {
  const presetBackgrounds = [
    "https://res.cloudinary.com/donklmnnv/image/upload/v1745844204/ChatGPT_Image_Apr_28_2025_06_13_13_PM_kijupk.png",
    "https://res.cloudinary.com/donklmnnv/image/upload/v1745843984/c3f4b78c825559fa2273fa3c6f4db7e11cf42123_zysa2c.png",
  ];
  const presetColors = [PresetColors.white, PresetColors.red, PresetColors.black];
  const resultTimes = [ResultTimes.halfTime, ResultTimes.fullTime];
  const gkPresetColors = [GKPresetColors.pink, GKPresetColors.red, GKPresetColors.black, GKPresetColors.gray];

  const [selectedbg, setSelectedbg] = useState("");
  const [selectedTime, setSelectedTime] = useState(ResultTimes.halfTime);
  const [selectedGkJersey, setSelectedGkJersey] = useState(effects?.gkPreset);
  useEffect(() => {
    if (effects?.gkPreset) {
      setSelectedGkJersey(effects.gkPreset)
    }
  }, [effects])


  const handleEffectToggle = async (effect) => {
    const updated = { ...effects };

    switch (effect) {
      case "blur":
        updated.isBlur = !effects?.isBlur;
        break;
      case "opacity":
        updated.isOpacity = !effects?.isOpacity;
        break;
      case "gradient":
        updated.isGradient = !effects?.isGradient;
        break;
      case "shadow":
        updated.isShadow = !effects?.isShadow;
        break;
      default:
        break;
    }

    await updateWithUndo(updated, "effects");
  };

  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const template_name = _.get(templateData, "template_name");
  const templateSetup = _.find(apiSetup.templates, { name: template_name });
  const availableFormats = _.get(templateSetup, "formats", []);
  useEffect(() => {
    if (effects?.jersey) {
      if (template_name === 'fcb_results') {
        setSelectedbg(effects.jersey)
      }
    }
    if (effects?.time) {
      if (template_name === 'fcb_results') {
        setSelectedTime(effects.time)
      }
    }
  }, [effects, template_name])
  return (
    <div>
      {/* Background Settings */}
      {
        template_name !== 'fcb_lineup' && <div className="section">
          <h4 className="editor-sidebar-title">Background Settings</h4>
          <div className="background-switch">
            <div className="background-switch-inner">
              <span>Remove Background</span>
              <Switch
                size="small"
                checked={backgroundAndResize?.removebg}
                onChange={async (checked) => {
                  const updated = { ...backgroundAndResize, removebg: checked };
                  updateWithUndo(updated, "backgroundAndResize");
                }}
                disabled={isFcbTemplate}
              />
            </div>
            <h3>Remove backgrounds instantly</h3>
          </div>
          {/* <Button className={`uploadBtn ${isFcbTemplate ? "disabled" : ""}`} icon={<UploadOutlined />}
            block>
            <input
              type="file"
              onChange={async (e) => {
                const bgFile = e.target.files[0];
                if (!bgFile) return;

                // Create a URL for the uploaded file (for preview and layering)
                const uploadedBgUrl = URL.createObjectURL(bgFile);

                // 1️⃣ Update the selected background (to show it immediately)
                setSelectedbg(uploadedBgUrl);
                addLayer(uploadedBgUrl);
              }}
              disabled={isFcbTemplate}
            />
            Upload Background
          </Button> */}
        </div>
      }


      <div className="section">
        <div className="jerseys-wrap">
          <div className="background-presets">
            {
              template_name === 'fcb_results' &&
              <>
                <h5 className="sub-title">
                  {"Time"} <InfoCircleOutlined />
                </h5>
                <div className="time-options" style={{ marginBottom: 12 }}>
                  {
                    resultTimes?.map((time, index) => (
                      <Button
                        key={index}
                        onClick={async () => {
                          setSelectedTime(time);
                          setSelectedResultTime(time);
                        }}
                        style={{
                          // backgroundColor: presetColor === '#363d43' ? 'white' : presetColor,
                          border:
                            selectedTime === time ? "3px solid #1677ff" : "",
                          margin: "0px",
                        }}
                      >
                        {time}
                      </Button>
                    ))
                  }
                </div>
                <h5 className="sub-title">
                  {"Jersey"} <InfoCircleOutlined />
                </h5>
                <div className="preset-options" style={{ marginBottom: 12 }}>
                  {
                    presetColors?.map((presetColor, index) => (
                      <Button
                        key={index}
                        onClick={async () => {
                          setSelectedbg(presetColor);
                          setSelectedJersey(presetColor)
                        }}
                        style={{
                          backgroundColor: presetColor === '#363d43' ? 'white' : presetColor,
                          border:
                            selectedbg === presetColor ? "3px solid #1677ff" : "",
                          margin: "0px",
                          padding: "0px",
                          width: "30px",
                          height: "30px",
                        }}
                      />
                    ))
                  }
                </div>
              </>
            }
            <h5 className="sub-title">
              {isFcbTemplate ? "Players Jersey" : "Background Presets"} <InfoCircleOutlined />
            </h5>
            <div className="preset-options">
              {isFcbTemplate
                ? presetColors?.map((presetColor, index) => (
                  <Button
                    key={index}
                    onClick={async () => {
                      setSelectedbg(presetColor);
                      addOrUpdatePreset(presetColor);
                    }}
                    style={{
                      backgroundColor: presetColor === '#363d43' ? 'white' : presetColor,
                      border:
                        selectedbg === presetColor ? "3px solid #1677ff" : "",
                      margin: "0px",
                      padding: "0px",
                      width: "30px",
                      height: "30px",
                    }}
                  />
                ))
                : presetBackgrounds.map((presetBackgroundUrl, index) => (
                  <Button
                    key={index}
                    onClick={async () => {
                      setSelectedbg(presetBackgroundUrl);
                      addOrUpdatePreset(presetBackgroundUrl);
                    }}
                    style={{
                      border:
                        selectedbg === presetBackgroundUrl
                          ? "3px solid #1677ff"
                          : "",
                      margin: "0px",
                      padding: "0px",
                      height: "100%",
                    }}
                  >
                    <img src={presetBackgroundUrl} />
                  </Button>
                ))}
            </div>
          </div>
          {
            isFcbTemplate && <div className="goalkeeper-preset">
              <h5 className="sub-title">
                Keepers Jersey <InfoCircleOutlined />
              </h5>
              <div className="preset-options">
                {gkPresetColors?.map((presetColor, index) => (
                  <Button
                    key={index}
                    onClick={async () => {
                      setSelectedGkJersey(presetColor);
                      addOrUpdateGkPreset(presetColor);
                    }}
                    style={{
                      backgroundColor: presetColor,
                      border:
                        selectedGkJersey === presetColor ? "3px solid #1677ff" : "",
                      margin: "0px",
                      padding: "0px",
                      width: "30px",
                      height: "30px",
                    }}
                  />
                ))}
              </div>
            </div>
          }

          {
            isFcbTemplate && <div className="goalkeeper-preset">
              <h5 className="sub-title">
                Has CL stars
              </h5>
              <Switch
                size="small"
                checked={effects?.hasCLStars}
                onChange={async (checked) => {
                  setCLStarsOnOrOff(checked)
                }}
              />
            </div>
          }
        </div>
      </div>

      {/* Crop & Resize */}
      <div className="section">
        {
          fcbResizeTemplates.includes(template_name) && <>
            <h4 className="editor-sidebar-title">Crop & Resize</h4>
            <div className="crop-resize-buttons">
              {cropButtons.map(({ label, url, selectedUrl }) => {
                return (
                  <Button
                    key={label}
                    onClick={
                      async () => {
                        // const updated = { ...effects, cropOption: label };
                        // updateWithUndo(updated, "effects");
                        setCropOption(label)
                      }
                    }
                    style={{
                      opacity: 1,
                      pointerEvents: "auto",
                    }}
                  >
                    <img
                      src={cropOption === label ? selectedUrl : url}
                      style={{ marginBlock: "3px" }}
                    />
                    {label}
                  </Button>
                );
              })}
            </div>
          </>
        }

        <h4 className="editor-sidebar-subtitle">Aspect Ratio</h4>
        <div className="aspect-ratio-buttons">
          {aspectRatios.map(({ format, label, url, selectedUrl, ratio }) => {
            const isDisabled = !availableFormats.includes(format);

            return (
              <Button
                key={label}
                onClick={
                  isDisabled
                    ? undefined // disables the click event
                    : async () => {
                      const updated = { ...effects, ratio: ratio, resize: 100 };
                      updateWithUndo(updated, "effects");
                      // setSelectedRatio(ratio);
                    }
                }
                disabled={isDisabled}
                style={{
                  opacity: isDisabled ? 0.5 : 1,
                  pointerEvents: isDisabled ? "none" : "auto",
                }}
              >
                <img
                  src={effects?.ratio === ratio ? selectedUrl : url}
                  style={{ marginBlock: "3px" }}
                />
                {label}
              </Button>
            );
          })}
        </div>
      </div>

      {/* Effects */}
      {
        template_name !== 'fcb_lineup' && <div className="section">
          <h4 className="editor-sidebar-title">Effects</h4>
          <div className="effects-buttons">
            <Button shape="circle" onClick={() => handleEffectToggle("blur")} disabled={isFcbTemplate}>
              <img src={Blur} />
            </Button>
            <Button shape="circle" onClick={() => handleEffectToggle("opacity")} disabled={isFcbTemplate}>
              <img src={Opacity} />
            </Button>
            <Button shape="circle" onClick={() => handleEffectToggle("gradient")} disabled={isFcbTemplate}>
              <img src={Gradient} />
            </Button>
            <Button shape="circle" onClick={() => handleEffectToggle("shadow")} disabled={isFcbTemplate}>
              <img src={Shadow} />
            </Button>
          </div>
        </div>
      }

    </div>
  );
}

export default EditTab;
